<div class="row">
  <div class="col-md-12" *ngIf="(!viewRole && actionsflow) || (!viewRole && status=='RG')">
    <div
      ng2FileDrop
      [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
      (fileOver)="fileOverBase($event)"
      [uploader]="uploader"
      class="well drop-zone"
    >
      <label class="file-drop-area text-muted text-center">
        <i class="fa font-5xl fa-upload"></i><br />{{visuals.droparea}}
        <input
          #fileUpload
          type="file"
          ng2FileSelect
          [uploader]="uploader"
          class="custom-file-input"
          style="display: none;"
        />
      </label>
    </div>
    <div *ngIf="quequeMsg" class="text-danger text-center">
      {{quequeMsg}}
    </div>
  </div>
  <div class="col-md-12" *ngIf="viewRole || (!viewRole && !actionsflow && status!='RG')">
    <div
      ng2FileDrop
      [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
      (fileOver)="fileOverBase($event)"
      [uploader]="uploader"
      class="well drop-zone"
    >
      <label class="file-drop-area text-muted text-center">
        <i class="fa font-5xl fa-upload"></i><br />{{visuals.droparea}} - You are not authorized to
        preform this action.
      </label>
    </div>
    <div *ngIf="quequeMsg" class="text-danger text-center">
      {{quequeMsg}}
    </div>
  </div>
</div>

<div *ngIf="uploader?.queue?.length > 0">
  <div class="card-block">
    <div class="row">
      <div
        class="col-sm-4 col-lg-3 mx-auto"
        style="display: block;"
        *ngFor="let item of uploader.queue"
      >
        <div class="media-items animation-fadeInQuick2">
          <div class="media-items-content">
            <i class="fa fa-file-text-o fa-5x text-primary"></i>
          </div>
          <p style="word-wrap: break-word;">
            <strong>{{ item?.file?.name | slice:0:50 }}</strong>
          </p>
          <button
            type="button"
            class="btn btn-success btn-xs"
            (click)="uploadCustom(item)"
            [disabled]="item.isReady || item.isUploading || item.isSuccess || uploading"
          >
            <span class="fa fa-upload" title="{{visuals.upload}}"></span>
          </button>

          <button
            type="button"
            class="btn btn-danger btn-xs"
            (click)="removeCustom(item)"
            [disabled]="uploading"
          >
            <span class="fa fa-close" title="{{visuals.remove}}"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="uploading" class="dataLoader"></div>

<div
  bsModal
  #errorModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left text-danger">
          <i
            class="fa fa-plus-circle fa-3x fa-rotate-45"
            style="vertical-align: -22%;margin-right: 20px;"
          ></i>
          {{visuals.errorDetails}}
        </h4>
        <button
          type="button"
          class="close pull-right"
          name="errorModalCloseButton"
          aria-label="Close"
          (click)="hideChildModal()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngFor="let error of resultDetails" class="row">
          <div class="col-sm-12">
            {{error}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
